/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApplicationDto,
  GetLegalFormsDescribedForSelfSignUpParams,
  GetLegalFormsForSelfSignUpParams,
  LeadFunnelStatusResponseDto,
  LegalFormDto,
  SelfSignUpAccountRequest,
  SelfSignupApplicationTypeDto,
  SelfSignupLeadFunnelStatusRequest,
  SelfSignupPersonalDetailsRequest,
  SelfSignupPhoneCountryCodesResponse,
  SelfSignupProductDetailsRequest,
  UserSlimDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class SelfSignUpApiController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags self-sign-up-api-controller
   * @name CreateLeadWithPersonalDetails
   * @request POST:/api/v1/self-signup/leads/personal-details
   */
  createLeadWithPersonalDetails = (
    data: SelfSignupPersonalDetailsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/v1/self-signup/leads/personal-details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createLeadWithPersonalDetailsPath = '/v1/self-signup/leads/personal-details'
  static createLeadWithPersonalDetailsMethod = 'POST'
  /**
   * No description
   *
   * @tags self-sign-up-api-controller
   * @name CreateUserWithOrganisation
   * @request POST:/api/v1/self-signup/creation
   */
  createUserWithOrganisation = (data: SelfSignUpAccountRequest, params: RequestParams = {}) =>
    this.http.request<UserSlimDto, any>({
      path: `/v1/self-signup/creation`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createUserWithOrganisationPath = '/v1/self-signup/creation'
  static createUserWithOrganisationMethod = 'POST'
  /**
   * No description
   *
   * @tags self-sign-up-api-controller
   * @name GetOrCreateApplication
   * @request POST:/api/v1/self-signup/application
   */
  getOrCreateApplication = (params: RequestParams = {}) =>
    this.http.request<ApplicationDto, any>({
      path: `/v1/self-signup/application`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static getOrCreateApplicationPath = '/v1/self-signup/application'
  static getOrCreateApplicationMethod = 'POST'
  /**
   * No description
   *
   * @tags self-sign-up-api-controller
   * @name UpdateLeadProductDetailsByOrganisationId
   * @request PATCH:/api/v1/self-signup/leads/product-details/{organisationId}
   */
  updateLeadProductDetailsByOrganisationId = (
    organisationId: string,
    data: SelfSignupProductDetailsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/v1/self-signup/leads/product-details/${organisationId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateLeadProductDetailsByOrganisationIdPath =
    '/v1/self-signup/leads/product-details/${organisationId}'
  static updateLeadProductDetailsByOrganisationIdMethod = 'PATCH'
  /**
   * No description
   *
   * @tags self-sign-up-api-controller
   * @name UpdateLeadFunnelStatusByUserId
   * @request PATCH:/api/v1/self-signup/leads/funnel-status/userId/{userId}
   */
  updateLeadFunnelStatusByUserId = (
    userId: string,
    data: SelfSignupLeadFunnelStatusRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/v1/self-signup/leads/funnel-status/userId/${userId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateLeadFunnelStatusByUserIdPath = '/v1/self-signup/leads/funnel-status/userId/${userId}'
  static updateLeadFunnelStatusByUserIdMethod = 'PATCH'
  /**
   * No description
   *
   * @tags self-sign-up-api-controller
   * @name GetLegalFormsForSelfSignUp
   * @request GET:/api/v1/self-signup/legal-forms
   */
  getLegalFormsForSelfSignUp = (
    query: GetLegalFormsForSelfSignUpParams,
    params: RequestParams = {},
  ) =>
    this.http.request<
      (
        | 'UNKNOWN'
        | 'GMBH'
        | 'UG'
        | 'AG'
        | 'GMBH_UND_CO_KG'
        | 'PARTG'
        | 'PARTGMBB'
        | 'EV'
        | 'KGAA'
        | 'KG_DE'
        | 'EK'
        | 'EG'
        | 'KDOR'
        | 'OHG'
        | 'EGBR'
        | 'STIFTUNG'
        | 'BV'
        | 'NV'
        | 'CV'
        | 'VERENIGING'
        | 'STICHTING'
        | 'COOPERATIVE_NL'
        | 'VOF'
        | 'EENMANSZAAK'
        | 'MAATSCHAP'
        | 'SL'
        | 'SLNE'
        | 'SA'
        | 'SC'
        | 'SARL'
        | 'SA_FR'
        | 'SAS'
        | 'SCS'
        | 'SNC'
        | 'SCA'
        | 'LTD'
        | 'PLC'
        | 'UNLTD'
        | 'LLP'
        | 'CLG'
        | 'GMBH_AT'
        | 'AG_AT'
        | 'KG'
        | 'OG'
        | 'GEN'
        | 'PRIVATSTIFTUNG'
        | 'FLEXKAPG'
        | 'SRL'
        | 'SPA'
        | 'SAS_IT'
        | 'SNC_IT'
        | 'SAA'
        | 'SC_IT'
        | 'SS'
        | 'AB'
        | 'KB'
        | 'HB'
        | 'BV_BE'
        | 'NV_BE'
        | 'COMMV'
        | 'SC_BE'
        | 'SPZOO'
        | 'SA_PL'
        | 'SPK'
        | 'SPJ'
        | 'SPP'
        | 'SKA'
        | 'LTD_IE'
        | 'DAC'
        | 'PLC_IE'
        | 'CLG_IE'
        | 'SE'
        | 'OTHER'
      )[],
      any
    >({
      path: `/v1/self-signup/legal-forms`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getLegalFormsForSelfSignUpPath = '/v1/self-signup/legal-forms'
  static getLegalFormsForSelfSignUpMethod = 'GET'
  /**
   * No description
   *
   * @tags self-sign-up-api-controller
   * @name GetLegalFormsDescribedForSelfSignUp
   * @request GET:/api/v1/self-signup/legal-forms-desc
   */
  getLegalFormsDescribedForSelfSignUp = (
    query: GetLegalFormsDescribedForSelfSignUpParams,
    params: RequestParams = {},
  ) =>
    this.http.request<LegalFormDto[], any>({
      path: `/v1/self-signup/legal-forms-desc`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getLegalFormsDescribedForSelfSignUpPath = '/v1/self-signup/legal-forms-desc'
  static getLegalFormsDescribedForSelfSignUpMethod = 'GET'
  /**
   * No description
   *
   * @tags self-sign-up-api-controller
   * @name GetLeadFunnelStatusByOrganisationId
   * @request GET:/api/v1/self-signup/leads/funnel-status/organisationId/{organisationId}
   */
  getLeadFunnelStatusByOrganisationId = (organisationId: string, params: RequestParams = {}) =>
    this.http.request<
      | 'LEAD_CREATED'
      | 'LEAD_QUALIFIED'
      | 'LEAD_DISQUALIFIED'
      | 'EMAIL_CONFIRMED'
      | 'PHONE_CONFIRMED'
      | 'LEAD_DETAILS_COMPLETED'
      | 'APPLICATION_CREATED'
      | 'APPLICATION_COMPLETED'
      | 'LEAD_DROP_OFF'
      | 'SELF_SIGNUP_DROP_OFF'
      | 'DEMO_DROP_OFF'
      | 'LEAD_PRODUCT_TOUR_DROP_OFF'
      | 'LEAD_AT_LEAST_ONE_PRODUCT_TOUR_PASSED_THEN_DROP_OFF'
      | 'SELF_SIGNUP_SUBMITTED'
      | 'DEMO_BOOKED',
      any
    >({
      path: `/v1/self-signup/leads/funnel-status/organisationId/${organisationId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getLeadFunnelStatusByOrganisationIdPath =
    '/v1/self-signup/leads/funnel-status/organisationId/${organisationId}'
  static getLeadFunnelStatusByOrganisationIdMethod = 'GET'
  /**
   * No description
   *
   * @tags self-sign-up-api-controller
   * @name GetLeadFunnelStatusWithFlowVersionByOrganisationId
   * @request GET:/api/v1/self-signup/leads/funnel-status-versioned/organisationId/{organisationId}
   */
  getLeadFunnelStatusWithFlowVersionByOrganisationId = (
    organisationId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<LeadFunnelStatusResponseDto, any>({
      path: `/v1/self-signup/leads/funnel-status-versioned/organisationId/${organisationId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getLeadFunnelStatusWithFlowVersionByOrganisationIdPath =
    '/v1/self-signup/leads/funnel-status-versioned/organisationId/${organisationId}'
  static getLeadFunnelStatusWithFlowVersionByOrganisationIdMethod = 'GET'
  /**
   * No description
   *
   * @tags self-sign-up-api-controller
   * @name GetApplicationTypeForOrganisation
   * @request GET:/api/v1/self-signup/application/type-by-organisation
   */
  getApplicationTypeForOrganisation = (params: RequestParams = {}) =>
    this.http.request<SelfSignupApplicationTypeDto, any>({
      path: `/v1/self-signup/application/type-by-organisation`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getApplicationTypeForOrganisationPath = '/v1/self-signup/application/type-by-organisation'
  static getApplicationTypeForOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags self-sign-up-api-controller
   * @name GetAllowedPhoneCountryCodes
   * @request GET:/api/v1/self-signup/allowed-phone-country-codes
   */
  getAllowedPhoneCountryCodes = (params: RequestParams = {}) =>
    this.http.request<SelfSignupPhoneCountryCodesResponse, any>({
      path: `/v1/self-signup/allowed-phone-country-codes`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAllowedPhoneCountryCodesPath = '/v1/self-signup/allowed-phone-country-codes'
  static getAllowedPhoneCountryCodesMethod = 'GET'
}
